(() => {
  const DURATION_MS = 350;

  /**
   * @param {HTMLElement} inner
   */
  function setHeight(inner, px) {
    inner.style.height = `${px}px`;
  }

  /**
   * @param {HTMLElement} inner
   */
  function forceReflow(inner) {
    // eslint-disable-next-line no-unused-expressions
    inner.offsetHeight;
  }

  /**
   * @param {HTMLDetailsElement} item
   */
  function animateOpen(item) {
    const inner = item.querySelector('.custom-faq__answer-inner');
    if (!(inner instanceof HTMLElement)) return;

    // Start from current height (0 if closed)
    inner.style.transition = 'none';
    const target = inner.scrollHeight;
    setHeight(inner, 0);
    forceReflow(inner);
    inner.style.transition = '';

    // Animate to content height
    requestAnimationFrame(() => {
      setHeight(inner, target);
    });

    // After animation, allow natural height changes
    window.setTimeout(() => {
      if (!item.open) return;
      inner.style.height = 'auto';
    }, DURATION_MS + 30);
  }

  /**
   * @param {HTMLDetailsElement} item
   */
  function animateClose(item) {
    const inner = item.querySelector('.custom-faq__answer-inner');
    if (!(inner instanceof HTMLElement)) return;

    // If it was auto, lock it to its current pixel height first
    const start = inner.scrollHeight;
    inner.style.transition = 'none';
    setHeight(inner, start);
    forceReflow(inner);
    inner.style.transition = '';

    requestAnimationFrame(() => {
      setHeight(inner, 0);
    });
  }

  /**
   * @param {HTMLElement} root
   */
  function init(root) {
    const items = Array.from(root.querySelectorAll('details.custom-faq__item'));
    if (!items.length) return;

    // Ensure only one is open on load (in case multiple were set open somehow)
    const initiallyOpen = items.find((d) => d.open);
    if (initiallyOpen) {
      for (const other of items) {
        if (other !== initiallyOpen) other.open = false;
      }
    }

    // Initialize heights so first open/close is always smooth
    for (const item of items) {
      const inner = item.querySelector('.custom-faq__answer-inner');
      if (!(inner instanceof HTMLElement)) continue;
      inner.style.height = item.open ? 'auto' : '0px';
    }

    for (const item of items) {
      if (item.hasAttribute('data-faq-initialized')) continue;
      item.setAttribute('data-faq-initialized', 'true');

      const summary = item.querySelector('summary');
      if (!(summary instanceof HTMLElement)) continue;

      summary.addEventListener('click', (e) => {
        // We control open/close to make the close animation smooth.
        e.preventDefault();

        const inner = item.querySelector('.custom-faq__answer-inner');
        if (!(inner instanceof HTMLElement)) {
          // Fallback to native if markup isn't present
          item.open = !item.open;
          return;
        }

        // If opening, close others first (animated) so only one is open.
        if (!item.open) {
          for (const other of items) {
            if (other === item) continue;
            if (!other.open) continue;
            const otherInner = other.querySelector('.custom-faq__answer-inner');
            if (otherInner instanceof HTMLElement) {
              other.setAttribute('data-closing', 'true');
              otherInner.style.opacity = '0';
              animateClose(other);
              window.setTimeout(() => {
                other.open = false;
                other.removeAttribute('data-closing');
                otherInner.style.opacity = '';
              }, DURATION_MS + 30);
            } else {
              other.open = false;
            }
          }

          item.removeAttribute('data-closing');
          item.open = true;
          inner.style.opacity = '';
          animateOpen(item);
          return;
        }

        // Closing: animate while still open, then set open=false after animation.
        item.setAttribute('data-closing', 'true');
        inner.style.opacity = '0';
        animateClose(item);
        window.setTimeout(() => {
          item.open = false;
          item.removeAttribute('data-closing');
          inner.style.opacity = '';
        }, DURATION_MS + 30);
      });
    }
  }

  function initAll() {
    document.querySelectorAll('.custom-faq').forEach((el) => {
      if (el instanceof HTMLElement) init(el);
    });
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', (e) => {
    const target = /** @type {HTMLElement | null} */ (e.target);
    if (!target) return;
    const root = target.querySelector('.custom-faq');
    if (root instanceof HTMLElement) init(root);
  });
})();

